import BlogArticle from '@/components/feature/BlogArticle';

const props = {
  "slug": "baie-vitree-qui-coince",
  "category": "Baie vitrée",
  "seoTitle": "Baie vitrée qui coince : roulettes, rail et réglage",
  "metaDescription": "Baie vitrée coulissante qui coince à Lyon ? Roulettes usées, rail encrassé, désalignement : causes détaillées et solutions pour un coulissement fluide.",
  "h1": "Baie vitrée qui coince : roulettes, rail et réglage",
  "datePublished": "2026-07-19",
  "dateLabel": "19 juillet 2026",
  "readingTime": "6 min",
  "heroImage": "/images/dfpro-roulette-2026.jpg",
  "heroAlt": "Baie vitrée qui coince à Lyon, roulettes et rail",
  "ctaTitle": "Baie dure ou qui déraille ?",
  "ctaText": "DFPRO Lyon change les roulettes et règle la baie. Devis gratuit.",
  "intro": [
    "Une baie vitrée coulissante qui devient dure à ouvrir, qui accroche, qui fait un bruit de raclement ou qui déraille, c'est presque toujours une histoire de <strong>roulettes</strong> et de <strong>rail</strong>. Le vantail vitré est lourd, et le moindre défaut sous le vantail se ressent immédiatement à la manœuvre.",
    "Ignorer le problème l'aggrave : une roulette usée abîme le rail, un rail marqué détruit les roulettes neuves, et un vantail qui force finit par endommager le mécanisme. Voici comment identifier la vraie cause et retrouver un coulissement fluide."
  ],
  "sections": [
    {
      "h2": "Les roulettes usées : la cause numéro un",
      "body": [
        "Sous chaque vantail coulissant se trouvent des roulettes (ou chariots) qui supportent tout le poids de la baie et la font glisser sur le rail. Avec le temps et le poids, elles s'usent, se déforment, se bloquent ou cassent.",
        "Résultat : le coulissement devient dur, bruyant, et le bas du vantail peut se mettre à frotter directement sur le rail. Le <a href=\"/changer-roulette-baie-vitree-lyon/\" class=\"text-primary-600 font-medium underline\">remplacement des roulettes</a> restaure un glissement souple — c'est l'intervention la plus fréquente sur une baie qui coince."
      ]
    },
    {
      "h2": "Le rail encrassé ou déformé",
      "body": [
        "Le rail accumule poussière, sable, graviers et débris qui gênent le passage des roulettes. Un nettoyage soigné de la gorge du rail améliore souvent nettement les choses, et fait partie de l'entretien de base d'une baie coulissante.",
        "Mais un rail <strong>déformé, marqué ou écrasé</strong> par des roulettes usées ne peut pas se contenter d'un nettoyage : il doit être redressé ou remplacé, faute de quoi il détruira prématurément des roulettes neuves. Vérifiez aussi que les butées d'extrémité sont bien en place."
      ]
    },
    {
      "h2": "Le désalignement et le réglage",
      "body": [
        "Une baie mal réglée ferme mal, laisse un jour d'air à la jonction des vantaux, ou force en fin de course. La plupart des baies disposent de <strong>vis de réglage</strong> au niveau des roulettes, qui permettent d'ajuster la hauteur et l'aplomb du vantail.",
        "Le <a href=\"/reglage-baie-vitree-coulissante-lyon/\" class=\"text-primary-600 font-medium underline\">réglage de la baie coulissante</a> (hauteur, alignement, compression du joint) rétablit une fermeture étanche et un coulissement régulier. C'est souvent le complément indispensable d'un changement de roulettes."
      ]
    },
    {
      "h2": "La serrure et le verrouillage",
      "body": [
        "Sur certaines baies, c'est le crochet ou la serrure de verrouillage qui se dérègle : la baie coulisse mais ne se ferme plus à clé, ou force au verrouillage. Ce point mérite d'être vérifié en même temps, car un mauvais réglage de la serrure peut donner l'impression que la baie « coince ».",
        "DFPRO Lyon traite l'ensemble — roulettes, rail, réglage, serrure — lors d'une <a href=\"/reparation-baie-vitree-lyon/\" class=\"text-primary-600 font-medium underline\">réparation de baie vitrée</a> complète."
      ]
    },
    {
      "h2": "Pourquoi confier ça à un professionnel",
      "body": [
        "Changer les roulettes suppose généralement de <strong>soulever et déposer le vantail</strong> — une opération délicate car le vitrage est très lourd et fragile, et une fausse manipulation peut le casser ou blesser. Le professionnel dispose de l'équipement et du savoir-faire pour le faire en sécurité.",
        "DFPRO Lyon intervient sur les baies coulissantes de toutes tailles et sur les portes coulissantes à galandage, à Lyon et dans la métropole. Devis gratuit, garantie 10 ans, intervention sous 24-48h."
      ]
    }
  ],
  "faq": [
    {
      "q": "Ma baie vitrée est très dure à ouvrir, d'où ça vient ?",
      "a": "Le plus souvent de roulettes usées ou bloquées, parfois d'un rail encrassé ou déformé. Le remplacement des roulettes et le nettoyage ou la remise en état du rail rétablissent un coulissement fluide. DFPRO Lyon intervient au 09 80 80 36 84."
    },
    {
      "q": "Peut-on changer les roulettes sans déposer la baie ?",
      "a": "Rarement : le vantail doit généralement être soulevé et déposé pour accéder aux roulettes situées dessous. C'est une opération technique, car le vitrage est lourd et fragile — mieux vaut la confier à un professionnel équipé."
    },
    {
      "q": "Un simple nettoyage du rail peut-il suffire ?",
      "a": "Parfois oui, si le rail est seulement encrassé et les roulettes encore bonnes. Mais si les roulettes sont usées ou le rail déformé, le nettoyage ne suffit pas et il faut remplacer les pièces concernées pour un résultat durable."
    },
    {
      "q": "Intervenez-vous sur les grandes baies et les galandages ?",
      "a": "Oui, nous intervenons sur les baies coulissantes de toutes dimensions et sur les portes coulissantes à galandage, à Lyon et dans la métropole, avec garantie 10 ans sur nos réparations."
    }
  ],
  "related": [
    {
      "title": "Fenêtre qui ferme mal : crémone, réglage et solutions",
      "href": "/blog/fenetre-qui-ferme-mal/"
    },
    {
      "title": "Double vitrage embué : pourquoi et comment y remédier",
      "href": "/blog/double-vitrage-embue/"
    }
  ]
};

export default function BaieVitreeQuiCoince() {
  return <BlogArticle {...props} />;
}
